import { ExternalEvent } from "../../../Core/EventManagement/ExternalEvents/ExternalEvent";
import { ExternalEventInfo } from "../../../Core/EventManagement/ExternalEvents/ExternalEventInfo";
import { IExternalEventManager } from "../../../Core/EventManagement/ExternalEvents/ExternalEventManager";
import { isModelEventInfo, ModelEvent } from "../../../Core/EventManagement/ModelEvents/ModelEvent";

import { IFormHookEventEmitter } from "./IFormHookCallContext";

export class FormHookEventEmitter implements IFormHookEventEmitter {
    readonly #externalEventManager: IExternalEventManager;

    public constructor(externalEventManager: IExternalEventManager) {
        this.#externalEventManager = externalEventManager;
    }

    public trigger(pathArr: string[], eventData?: ExternalEventInfo | ModelEvent): void {
        if (isModelEventInfo(eventData)) {
            throw new Error("Trigger in hook function does not support data events");
        } else {
            // @ts-ignore
            const event: ExternalEvent = [pathArr, eventData];
            this.#externalEventManager.triggerExternalEvents([event]);
        }
    }
}
